import { __exports as codabar } from "./index181.js";
import { __require as requireBarcode } from "./index158.js";
var hasRequiredCodabar;
function requireCodabar() {
  if (hasRequiredCodabar) return codabar;
  hasRequiredCodabar = 1;
  Object.defineProperty(codabar, "__esModule", {
    value: true
  });
  codabar.codabar = void 0;
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var codabar$1 = (function(_Barcode) {
    _inherits(codabar2, _Barcode);
    function codabar2(data, options) {
      _classCallCheck(this, codabar2);
      if (data.search(/^[0-9\-\$\:\.\+\/]+$/) === 0) {
        data = "A" + data + "A";
      }
      var _this = _possibleConstructorReturn(this, (codabar2.__proto__ || Object.getPrototypeOf(codabar2)).call(this, data.toUpperCase(), options));
      _this.text = _this.options.text || _this.text.replace(/[A-D]/g, "");
      return _this;
    }
    _createClass(codabar2, [{
      key: "valid",
      value: function valid() {
        return this.data.search(/^[A-D][0-9\-\$\:\.\+\/]+[A-D]$/) !== -1;
      }
    }, {
      key: "encode",
      value: function encode() {
        var result = [];
        var encodings = this.getEncodings();
        for (var i = 0; i < this.data.length; i++) {
          result.push(encodings[this.data.charAt(i)]);
          if (i !== this.data.length - 1) {
            result.push("0");
          }
        }
        return {
          text: this.text,
          data: result.join("")
        };
      }
    }, {
      key: "getEncodings",
      value: function getEncodings() {
        return {
          "0": "101010011",
          "1": "101011001",
          "2": "101001011",
          "3": "110010101",
          "4": "101101001",
          "5": "110101001",
          "6": "100101011",
          "7": "100101101",
          "8": "100110101",
          "9": "110100101",
          "-": "101001101",
          "$": "101100101",
          ":": "1101011011",
          "/": "1101101011",
          ".": "1101101101",
          "+": "1011011011",
          "A": "1011001001",
          "B": "1001001011",
          "C": "1010010011",
          "D": "1010011001"
        };
      }
    }]);
    return codabar2;
  })(_Barcode3.default);
  codabar.codabar = codabar$1;
  return codabar;
}
export {
  requireCodabar as __require
};
//# sourceMappingURL=index142.js.map
